import Http from '../../http';

class CabServices {
  static async findCabRequestById(id) {
    return Http.get(`/cabRequest/${id}`);
  }
  static async create(data) {
    return Http.post('/cabRequest', data);
  }

  static async update(id, data) {
    return Http.update(`/cabRequest/${id}`, data);
  }
}

export default CabServices;
